"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Vuex plugin to get TokenService status updates.
 * Your Vuex store must define a mutation to receive the update,
 * you can specify the mutation name when creating the store plugin.
 */
function createVuexPlugin(tokenService, statusUpdateMutationName) {
    return (store) => {
        tokenService.subscribeStatusUpdates((status) => store.commit(statusUpdateMutationName, { ...status }));
    };
}
exports.default = createVuexPlugin;
